import React, { useRef } from 'react';
import { JourneyMenu } from 'src/common/JourneyMenu';
import { DoorOpenStrongIcon, ShareAltLinkOutRegularIcon } from 'src/monet/icons';
import { useCurrentUser } from 'src/store/user';
import { functionNoop } from 'src/utils/function/noop';
import { PageSidebarItemClasses } from './item';

const menuItemClasses = 'text-bedrock-p text-bedrock-black text-left';

export const PageSidebarHelpMenu = () => {
  const { currentUser } = useCurrentUser();

  const menuOpenRef = useRef(functionNoop);
  const menuCloseRef = useRef(functionNoop);

  const navigateHelp = () => {
    window.Beacon('open');
    window.Beacon('navigate', '/ask/chat/')
    menuCloseRef.current();
  };

  const navigateRequest = () => {
    window.open('mailto:support@journey.io','_blank');
    menuCloseRef.current();
  }

  return (
    <JourneyMenu
      placement='bottom-end'
      openRef={menuOpenRef}
      closeRef={menuCloseRef}
      renderOrigin={() => (
        <div className={PageSidebarItemClasses}>
          <div className='flex items-center shrink-0 space-x-sm'>
            <DoorOpenStrongIcon className='w-4 h-4' />
            <span className='text-bedrock-p-strong'>Help</span>
          </div>
        </div>
      )}
    >
      <JourneyMenu.Item className={menuItemClasses} onClick={navigateHelp}>
        <div className='flex items-center space-x-2'>
          <ShareAltLinkOutRegularIcon />
          <span>Get help</span>
        </div>
      </JourneyMenu.Item>
      <JourneyMenu.Item className={menuItemClasses} onClick={navigateRequest}>
          <div className='flex items-center space-x-2'>
            <ShareAltLinkOutRegularIcon />
            <span>Request a feature</span>
          </div>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
